<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12 mb-4">
        <Total></Total>
      </div>
      <div class="col-12 mb-4">
        <Daily></Daily>
      </div>
      <div class="col-12 mb-4">
        <Member></Member>
      </div>
    </div>
  </div>
</template>

<script>
const exactMath = require('exact-math');
import {Modal} from 'bootstrap'
import { mapMutations } from "vuex";
import Total from '@/components/Statistics/Total.vue';
import Daily from '@/components/Statistics/Daily.vue';
import Member from '@/components/Statistics/Member.vue';
export default {
  name: "tables",
  components: {
    Total,Daily,Member
  },
  data() {
    return {
      limit : 10,
      page : 1,
      max_page : 0,
      show : 3,
      s_code :  this.$store.state.s_code,
      auth :  this.$store.state.auth,
      list : [],
      search_status : '',
      search_type : '',
      t_balance : '',
      add_type :'',
      add_balance : '',
      add_bank_name : '',
      add_bank_account : '',
      add_bank_holder : '',
      add_address : '',
      add_memo : '',
      mobile :this.$store.state.mobile,
      show_mobile :this.$store.state.show_mobile,

    };
  },
  mounted(){
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    this.$store.state.isAbsolute = false;
    this.AddModal = new Modal(document.getElementById('add_exchange'));
    this.GetExchangeList();
    if(this.mobile ==true){
      if(this.show_mobile ==true){
        this.navbarMinimize();
      } 
    }
  },
  methods:{
    ...mapMutations(["navbarMinimize"]),
    ChangeExchangeStatus(status,no){
      if(status =='H'){
        this.$alert.confirm("환전신청을 취소 하시겠습니까?").then(
          ()=>{
            this.ChangeStatusExchange(no);
          }
        ).catch(()=>{})
      }
    },
    GetTokenBalance(){
      this.axios.post('/admin/common/token/balance', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.t_balance = res.data.balance;
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    CheckTypeClass(status){
      if(status =='C'){
        return "bg-gradient-warning";
      }else if(status =='A'){
        return "bg-gradient-success";
      }else if(status =='E'){
        return "bg-gradient-primary";
      }
    },
    CheckType(type){
      if(type =='C'){
        return "현금";
      }else if(type =='A'){
        return "계좌이체";
      }else if(type =='E'){
        return "코인이체(이더리움)";
      }
    },
    CheckStatusClass(status){
      if(status =='H'){
        return "bg-gradient-warning";
      }else if(status =='Y'){
        return "bg-gradient-success";
      }else if(status =='C'){
        return "bg-gradient-danger";
      }else if(status =='P'){
        return "bg-gradient-primary";
      }
    },
    CheckStatus(status){
      if(status =='H'){
        return "대기중";
      }else if(status =='Y'){
        return "처리완료";
      }else if(status =='C'){
        return "취소";
      }else if(status =='P'){
        return "진행중";
      }
    },
    
    ClickPaging(i){
      this.page =i;
      this.GetExchangeList();
    },
    CheckPage(i){
      
      const show = this.show;
      const page = this.page;
      var add_class ='';
      if((i+2) == show){
        if(page ==i){
          add_class = " active ";
        }
        
      }else if((i+1) == show){
        if(page ==i){
          add_class = " active ";
        }
        
      }else if((i) == show){
        if(page ==i){
          add_class = " active ";
        }
        
      }else if((i-1) == show){
        if(page ==i){
          add_class = " active ";
        }
        
      }else if((i-2) == show){
        if(page ==i){
          add_class = " active ";
        }
      }else{
        add_class += 'd-none';
      }


      return add_class;

    },
    PrevPage(){
      const show = this.show;
      const show_prev = exactMath.sub(show,1);

      if(show_prev >= 3){
        this.show = show_prev;
      }else{
        this.show = show;
      }
    },
    NextPage(){
      const show = this.show;
      const show_next = exactMath.add(show,1);
      const max = exactMath.sub(this.max_page,2);

      if(show_next <= max){
        this.show = show_next;
      }else{
        this.show = max;
      }
    },
    SearchList(){
      this.page = 1;
      this.show = 3;
      this.GetExchangeList();
    },
    GetExchangeList(){
      const page = this.page;
      const type = this.search_type;
      const status = this.search_status;
      const s_code = this.s_code;
      const limit = this.limit;

      this.axios.post('/admin/exchange/list', {type,status,page,s_code,limit}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.max_page = res.data.count;
              this.list = res.data.list;
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    AddExchange(){
      const t_balance = this.t_balance;
      const balance = this.add_balance;

      if(balance ==0 ||balance ==''){
        this.$alert.alert("환전할 코인 개수를 확인해주세요.").then(
          ()=>{
             this.AddModal.show();
          }
        )
        return false;
      }

      const c_balance = exactMath.sub(t_balance,balance);
      
      if(c_balance < 0 ){
        this.$alert.alert("보유하신 코인을 확인해주세요.").then(
          ()=>{
             this.AddModal.show();
          }
        )
        return false;
      }

      const type = this.add_type;
      const bank_name = this.add_bank_name;
      const bank_account = this.add_bank_account;
      const bank_holder = this.add_bank_holder;
      const address = this.add_address;
      const memo = this.add_memo;

      if(type =="A"){
        if(bank_name ==''){
          this.$alert.alert("은행명을 입력해주세요.").then(
            ()=>{
              this.AddModal.show();
            }
          );
          return false;
        }

        if(bank_account ==''){
          this.$alert.alert("계좌번호를 입력해주세요.").then(
            ()=>{
              this.AddModal.show();
            }
          );
          return false;
        }

        if(bank_holder ==''){
          this.$alert.alert("예금주를 입력해주세요.").then(
            ()=>{
              this.AddModal.show();
            }
          );
          return false;
        }

      }

      if(type =="E"){
        if(address ==''){
          this.$alert.alert("지갑 주소를 입력해주세요.").then(
            ()=>{
              this.AddModal.show();
            }
          );
          return false;
        }
      }

      this.axios.post('/admin/exchange/add', {type,balance,bank_account,bank_holder,bank_name,address,memo}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.$alert.alert("환전 신청하였습니다.").then(
                ()=>{
                  this.$router.go();
                }
              );
            }else if(res.data.code=='100'){
              this.$alert.alert("정보를 확인해 주세요.").then(
                ()=>{
                  this.AddModal.show();
                }
              );
              this.SearchList();
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    ChangeStatusExchange(no){
      this.axios.post('/admin/exchange/cancel', {no}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.$alert.alert("환전을 취소하였습니다.");
              this.SearchList();
            }else if(res.data.code=='100'){
              this.$alert.alert("환전 취소 실패");
              this.SearchList();
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    }
  }
};
</script>
